import { Component, OnInit } from '@angular/core';
import { NavigationService } from '../navigation.service';
import { BreakpointsService } from '../breakpoints.service';
import { CursorService } from '../cursor.service';
import { LayoutService } from '../layout.service';
import { ImageGalleryService } from '../image-gallery.service';
import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';

@Component({
  selector: 'app-view-with-nav-bar',
  templateUrl: './view-with-nav-bar.component.html',
  styleUrls: ['./view-with-nav-bar.component.scss'],
  host: {
    '[class]': 'getClass()',
  },
  animations: [
    trigger('navBarState', [
      state('hidden', style({
        opacity: '0',
        display: 'none'
      })),
      state('visible',   style({
        opacity: '1',
        display: 'block'
      })),
      transition('hidden => visible', animate('250ms ease-in')),
      transition('visible => hidden', animate('250ms ease-out'))
    ])
  ]
})
export class ViewWithNavBarComponent implements OnInit {
  constructor(
    private NavigationService: NavigationService,
    private BreakpointsService: BreakpointsService,
    private CursorService: CursorService,
    public ImageGalleryService: ImageGalleryService,
    public LayoutService: LayoutService
  ) {
  }

  ngOnInit() {
  }

  getClass() {
    let _class = '';
    if (this.CursorService.cursor !== null) {
      _class = `cursor-${this.CursorService.cursor}`;
    }
    return _class;
  }

  navBarState() {
    return (this.NavigationService.isHiddenDesktop && this.BreakpointsService.device === 'desktop') ||  this.NavigationService.isHidden ? 'hidden' : 'visible';
  }
}



// WEBPACK FOOTER //
// ./src/app/view-with-nav-bar/view-with-nav-bar.component.ts